import { render } from "./DeleteLocationForm.vue?vue&type=template&id=c6ecc832"
import script from "./DeleteLocationForm.vue?vue&type=script&lang=js"
export * from "./DeleteLocationForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__